import { Container } from "../shared/components/layout/container.js";
import { ErrorDialog } from "../shared/components/feedback/error-dialog.js";
import { Poster } from "../shared/components/layout/poster.js";
import { VideoGestures } from "../shared/skins/shared/video/gestures.js";
import { VideoHotkeys } from "../shared/skins/shared/video/hotkeys.js";
import { BufferingIndicator } from "./components/feedback/buffering-indicator.js";
import { MinimalVideoControls } from "./controls.js";
import { VideoStatusIndicators } from "./skins/shared/video/status-indicators.js";
import { jsx, jsxs } from "react/jsx-runtime";
import { cn } from "@videojs/utils/style";
//#region src/internal/skins/minimal-video/skin.tsx
/** @jsxImportSource react */
function MinimalVideoSkin({ children, className, renderPoster, ...props } = {}) {
	return /* @__PURE__ */ jsxs(Container, {
		className: cn("video-skin", className),
		"data-theme": "minimal",
		"data-preset": "video",
		...props,
		children: [
			children,
			/* @__PURE__ */ jsx(Poster, { renderImage: renderPoster }),
			/* @__PURE__ */ jsx(BufferingIndicator, {}),
			/* @__PURE__ */ jsx(ErrorDialog, {}),
			/* @__PURE__ */ jsx(MinimalVideoControls, {}),
			/* @__PURE__ */ jsx(VideoHotkeys, {}),
			/* @__PURE__ */ jsx(VideoGestures, {}),
			/* @__PURE__ */ jsx(VideoStatusIndicators, {})
		]
	});
}
//#endregion
export { MinimalVideoSkin };

//# sourceMappingURL=skin.js.map